<template>
    <div id="index" v-cloak>
        <!-- banner -->
        <div class="banner banner_swiper1 swiper-container">
            <!-- 左右滑动按钮 -->
            <div class="swiper-wrapper">
                <div class="swiper_item swiper-slide">
                    <img src="@/assets/img/guide1.png" alt="">
                </div>
                <div class="swiper_item swiper-slide">
                    <img src="@/assets/img/guide2.png" alt="">
                </div>
                <div class="swiper_item swiper-slide">
                    <img @click.stop="start" src="@/assets/img/guide3.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "index",
        data() {
            return {
                user: {},//用户信息
            };
        },
        computed: {},
        components: {

        },
        watch: {

        },
        methods: {
            start() {//开始
                localStorage.setItem("GUIDE", 1);
                this.$router.replace("/m_home");
            },
            swiperFun() {
                //实例swiper
                new Swiper(".banner_swiper1", {

                });
            },
        },
        mounted() {
            let that = this;
            if (localStorage.getItem("GUIDE") == 1) {
                this.$router.replace("/m_home");
            } else {
                this.$nextTick(() => {
                    that.swiperFun();
                })
            }
            if (this._isMobile()) {

            } else {
                // alert("pc端");
                this.$router.replace("/");
            }

        }
    };
</script>

<style scoped>
    html,
    body {
        max-width: 100vw;

    }


    .visible-xs {
        width: 100vw;
        overflow: hidden;
        background: #F7FAFC;
        padding-bottom: 0 !important;
    }

    .banner_swiper1 .swiper_item img {
        width: 100vw;
        height: 100vh;
        object-fit: cover;
    }
</style>


// WEBPACK FOOTER //
// src/components/min_view/m_guide.vue